/**
 * Facebook Pixel utility functions for event tracking
 */

// Facebook Pixel ID
const PIXEL_ID = '1586597318715811';

/**
 * Track a standard event
 * @param {string} eventName - Name of the standard event (e.g., 'Purchase', 'Lead', 'Contact')
 * @param {Object} params - Optional parameters for the event
 */
export const trackEvent = (eventName, params = {}) => {
  if (window.fbq && typeof window.fbq === 'function') {
    window.fbq('track', eventName, params);
  } else {
    // Check if marketing cookies are disabled
    const marketingEnabled = localStorage.getItem('cookie_marketing') === 'true';
    const consentGiven = localStorage.getItem('cookie_consent') === 'accepted';
    
    if (!consentGiven || !marketingEnabled) {
      // Silently fail if marketing cookies are disabled
      return;
    }
    
    // If consent is given but pixel not loaded yet, queue the event
    if (!window.fbqEvents) {
      window.fbqEvents = [];
    }
    window.fbqEvents.push({ type: 'track', eventName, params });
  }
};

/**
 * Track a custom event
 * @param {string} eventName - Name of the custom event
 * @param {Object} params - Optional parameters for the event
 */
export const trackCustomEvent = (eventName, params = {}) => {
  if (window.fbq && typeof window.fbq === 'function') {
    window.fbq('trackCustom', eventName, params);
  } else {
    // Check if marketing cookies are disabled
    const marketingEnabled = localStorage.getItem('cookie_marketing') === 'true';
    const consentGiven = localStorage.getItem('cookie_consent') === 'accepted';
    
    if (!consentGiven || !marketingEnabled) {
      // Silently fail if marketing cookies are disabled
      return;
    }
    
    // If consent is given but pixel not loaded yet, queue the event
    if (!window.fbqEvents) {
      window.fbqEvents = [];
    }
    window.fbqEvents.push({ type: 'trackCustom', eventName, params });
  }
};

/**
 * Standard events as defined by Facebook
 */
export const StandardEvents = {
  ADD_PAYMENT_INFO: 'AddPaymentInfo',
  ADD_TO_CART: 'AddToCart',
  ADD_TO_WISHLIST: 'AddToWishlist',
  COMPLETE_REGISTRATION: 'CompleteRegistration',
  CONTACT: 'Contact',
  CUSTOMIZE_PRODUCT: 'CustomizeProduct',
  DONATE: 'Donate',
  FIND_LOCATION: 'FindLocation',
  INITIATE_CHECKOUT: 'InitiateCheckout',
  LEAD: 'Lead',
  PURCHASE: 'Purchase',
  SCHEDULE: 'Schedule',
  SEARCH: 'Search',
  START_TRIAL: 'StartTrial',
  SUBMIT_APPLICATION: 'SubmitApplication',
  SUBSCRIBE: 'Subscribe',
  VIEW_CONTENT: 'ViewContent'
};

/**
 * Check if Facebook Pixel is loaded and available
 * @returns {boolean}
 */
export const isPixelAvailable = () => {
  return window.fbq && typeof window.fbq === 'function';
};

/**
 * Check if marketing cookies are enabled
 * @returns {boolean}
 */
export const isMarketingEnabled = () => {
  const marketingEnabled = localStorage.getItem('cookie_marketing') === 'true';
  const consentGiven = localStorage.getItem('cookie_consent') === 'accepted';
  return consentGiven && marketingEnabled;
};

// Do NOT initialize the pixel here - it's already initialized in main.js based on cookie consent
// This file only provides utility functions for tracking events

export default {
  trackEvent,
  trackCustomEvent,
  StandardEvents,
  PIXEL_ID,
  isPixelAvailable,
  isMarketingEnabled
}; 